/* eslint-disable */
import React, { useContext } from "react";
import { Button } from "antd";
import { PathContext } from "../../contexts";

export default React.memo(function PathButton(props) {
  // console.log('RegisterButton', props)
  const pt = useContext(PathContext);
  function changePath() {
    // console.log('PathButton', pt)
    if (pt.path === props.to) {
      return;
    }
    pt.changePath(props.to);
  }
  const { className, type = "link", children } = props;
  return (
    <a className={className} type={type} onClick={changePath} style={{marginBottom: 10}}>
      {children}
    </a>
  );
});
/* eslint-disable */
